module.exports = __webpack_public_path__ + "img/Icon_pastorders.3fba6420.svg";